import * as _ from 'lodash';
import * as DateUtils from '../../../../../HelperMethods/DateUtils';
import { MARKER_TYPE, RESOLVED_VIA } from './constants';
import { STATUS_LIST } from '../../../../../HelperMethods/enums';
import { EditMode, TASK_ACTION } from '../../../../../HelperMethods/constants';
import { mapEntityToFormValues, mapFormValuesToEntity } from '../../../../../HelperMethods/FormUtils';
import { parseJSONStringToObject } from '../../../../../HelperMethods/UtilityFunctions';
import { mergeDropDownAssigneeWithTaskAssignee } from '../../../../../HelperMethods/TaskUtilities';

export function mapTaskToFormValues(task, schema) {
  const clonedTask = _.clone(task);
  clonedTask.data = parseJSONStringToObject(clonedTask.data) ?? {};
  clonedTask.globalAttributes = parseJSONStringToObject(clonedTask.globalAttributes) ?? {};
  const formValues = mapEntityToFormValues(clonedTask, schema);
  return formValues;
}
const fieldsToOmit = {
  [EditMode.PUBLISHED]: [
    'taskType',
    'asset',
    'assignee',
    'createdOn',
    'createdBy',
    'modifiedOn',
    'modifiedBy',
    'tenantId',
    'isVirtual',
    'sendNotification',
  ],
  [EditMode.UNPUBLISHED]: [
    'taskType',
    'asset',
    'assignee',
    'modifiedOn',
    'modifiedBy',
    'tenantId',
    'isVirtual',
    'sendNotification',
  ],
};

export function taskHistoryMapper(taskHistory) {
  const obj = {};
  obj.date = DateUtils.convertUTCDateStringToYYYYMMDDHHMMSSFormat(taskHistory.modifiedOn);

  if (taskHistory.createOrUpdate === 'Create') {
    obj.createOrUpdate = 'Create';
  } else if (taskHistory.createOrUpdate === 'Update') {
    obj.createOrUpdate = 'Update';
  }
  obj.attribute = taskHistory.attribute;
  obj.section = taskHistory.section;
  obj.taskAfter = taskHistory.taskafter;
  obj.taskBefore = taskHistory.taskbefore;
  obj.user = taskHistory.user;

  return obj;
}
export function schemaTaskHistory() {
  return test;
}

export function mapFormValuesToTask(
  formValues,
  schema,
  {
    originalTask,
    picklistOptions,
    loggedInUser,
    fieldId,
    tasksEditMode,
    taskActionBeingDone,
    parentTaskTemplate = {},
    childTasksDictByWorkflowId = {},
  }
) {
  const setValueParams = {
    task: originalTask,
    fieldId,
    loggedInUser,
    ...picklistOptions,
  };
  const { firstTaskValid = false } = formValues;
  const task = mapFormValuesToEntity(formValues, schema, setValueParams);
  let clonedOriginalTask = _.cloneDeep(originalTask);
  const selectedTaskTypeId = formValues.s_tasktype;
  const selectedTaskType = picklistOptions.taskTypeOptions.items.find((tt) => tt.key === selectedTaskTypeId);
  if (taskActionBeingDone === TASK_ACTION.APPROVE) {
    let needAcceptanceFlag = false;
    if (selectedTaskType) {
      needAcceptanceFlag = selectedTaskType.originalobject.needAcceptance;
    }
    task.status = needAcceptanceFlag ? STATUS_LIST.NOT_READY.key : STATUS_LIST.OPEN.key;
    task.approvedBy = loggedInUser.userName;
    task.approvedOn = new Date().toISOString();
  }
  if (taskActionBeingDone === TASK_ACTION.CREATE) {
    task.createdOn = new Date().toISOString();
    task.createdBy = loggedInUser.userName;
  }

  if (taskActionBeingDone === TASK_ACTION.CREATE && selectedTaskType) {
    task.formSchemaId = selectedTaskType.originalobject.formSchemaId;
  } else if (
    taskActionBeingDone === TASK_ACTION.UPDATE &&
    selectedTaskType &&
    clonedOriginalTask.taskTypeId !== selectedTaskTypeId
  ) {
    task.formSchemaId = selectedTaskType.originalobject.formSchemaId;
  }

  clonedOriginalTask.data = parseJSONStringToObject(clonedOriginalTask.data) ?? {};
  task.data = _.merge(clonedOriginalTask.data, task.data);
  _.assign(clonedOriginalTask, task);
  clonedOriginalTask.data = clonedOriginalTask.data || {};
  clonedOriginalTask.globalAttributes = parseJSONStringToObject(clonedOriginalTask.globalAttributes) ?? {};
  clonedOriginalTask = _.omit(clonedOriginalTask, fieldsToOmit[tasksEditMode]);
  if (taskActionBeingDone === TASK_ACTION.CREATE) {
    clonedOriginalTask.createdOn = task.createdOn;
  }
  if (
    // taskActionBeingDone === TASK_ACTION.CREATE &&
    (selectedTaskType.originalobject.isParent || selectedTaskType.originalobject.isDynamicParentChild) &&
    parentTaskTemplate &&
    parentTaskTemplate.items &&
    parentTaskTemplate.items.length
  ) {
    // add template to the cloned original task
    const template = parentTaskTemplate.items.map((item) => {
      const {
        originalItem,
        assetId,
        priority,
        timeToNextPriority,
        assigneeOptions = [],
        equipmentOptions = [],
        assigneeIdsToEvaluate = [],
        equipmentIdToEvaluate = '',
      } = item;
      const clonedOriginalItem = _.cloneDeep(originalItem);
      const childTask = childTasksDictByWorkflowId[clonedOriginalItem.workflowStepId] || {};
      if (assetId) {
        clonedOriginalItem.assetId = assetId;
      }
      if (priority) {
        clonedOriginalItem.priority = priority;
      }
      if (timeToNextPriority) {
        clonedOriginalItem.timeToNextPriority = timeToNextPriority;
      }

      if ((assigneeIdsToEvaluate && assigneeIdsToEvaluate.length) || equipmentIdToEvaluate) {
        const assigneeOptionsDict = _.keyBy(assigneeOptions, 'key');
        const equipmentOptionsDict = _.keyBy(equipmentOptions, 'key');

        const finalAssigneeIds = mergeDropDownAssigneeWithTaskAssignee({
          dropdownIds: [...(assigneeIdsToEvaluate || []), ...(equipmentIdToEvaluate ? [equipmentIdToEvaluate] : [])],
          assigneeIds: childTask.assigneeIds || [],
          needEquipment: !!equipmentIdToEvaluate,
          openToNotReady: false,
          dropdownIdsAssigneeMap: {
            ...assigneeOptionsDict,
            ...equipmentOptionsDict,
          },
        });

        clonedOriginalItem.assigneeIds = finalAssigneeIds;
      }

      return clonedOriginalItem;
    });
    clonedOriginalTask.template = template;
  }
  if (firstTaskValid) {
    clonedOriginalTask.firstTaskValid = firstTaskValid;
  }
  delete clonedOriginalTask.score;
  delete clonedOriginalTask.increment;
  return clonedOriginalTask;
}

export const mapErrorToField = ({ formValues }) => {
  const error = [];
  const parts = _.get(formValues, 'parts_required', []);
  parts.forEach((part, index) => {
    const errObj = {};
    if (part.picklistId && !part.picklistOptionId) {
      errObj.picklistOptionId = 'Part is not selected';
    }
    if (part.picklistId && !parseInt(part.quantity, 10)) {
      errObj.quantity = 'Quantity is not defined';
    }
    if (!part.picklistId && (part.quantity || part.picklistOptionId)) {
      errObj.picklistId = 'Parts picklist is not selected';
    }
    if (Object.keys(errObj).length !== 0) {
      error[index] = errObj;
    }
  });
  return { isValid: error.length === 0, error };
};
export const findLatLongForBound = (task) => {
  const location = [];
  const stopLat = _.get(task, 'asset.stop.latitude', '');
  const stopLng = _.get(task, 'asset.stop.longitude', '');
  const taskData = parseJSONStringToObject(task.data);
  const resovedAtLat = taskData.s_resolved_lat;
  const resolvedAtLng = taskData.s_resolved_long;
  if (stopLat && stopLng) {
    location.push({ lat: stopLat, lng: stopLng, type: MARKER_TYPE.STOP_MARKER });
  }
  if (resovedAtLat && resolvedAtLng) {
    location.push({ lat: resovedAtLat, lng: resolvedAtLng, type: MARKER_TYPE.RESOLVED_AT_MARKER });
  }
  return location;
};

export const shouldMapBeShown = ({ values }) => {
  return values.audit_resolvedvia && values.audit_resolvedvia === RESOLVED_VIA.MOBILE;
};

export function setPicklistOptionsToState(state, optionsKey, isLoading, items, isSearching = false) {
  return {
    ...state,
    [optionsKey]: {
      isLoading,
      items,
      isSearching,
    },
  };
}
